/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/pin_code'
export default icon
